import Container from "../../../../components/container";
import Icon from "../../../../components/icon";
import { Charity } from "../../../../models";
import { DeleteCharity, UpdateCharity } from "./buttons";

export default function CharitiesTable({
  charities,
}: {
  charities: Charity[];
}) {
  return (
    <Container className="">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {charities?.map((charity) => (
          <div
            key={charity.id}
            className="mb-2 w-full rounded-md bg-white p-4"
          >
            <h2>{charity.name}</h2>
            <div className="flex items-center justify-between pb-4 mt-2">
              <div className="flex items-center gap-2">
                <p>Registration:</p>
                <p className="text-sm text-gray-500">{charity.registrationNo || "N/A"}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <p>Website:</p>
              <p className="text-sm text-gray-500">{charity.website || "N/A"}</p>
            </div>
            <div className="flex items-center gap-2">
              <p>Income:</p>
              <p className="text-sm text-gray-500">${charity.income || 0}</p>
            </div>
            <div className="flex items-center gap-2">
              <p>Expenditure:</p>
              <p className="text-sm text-gray-500">${charity.expenditure || 0}</p>
            </div>
            <div className="flex items-center justify-between pb-4 mt-2">
              {charity.id ? (
                <div className="w-full flex items-center justify-center gap-2">
                  <UpdateCharity id={charity.id} />
                  <DeleteCharity id={charity.id} />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Id</th>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Registration No</th>
            <th className="px-6 py-3">Website</th>
            <th className="px-6 py-3">Income</th>
            <th className="px-6 py-3">Expenditure</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {charities.map((charity) => (
            <tr key={charity.id} className="border-b">
              <td className="whitespace-nowrap px-6 py-3">{charity.id}</td>
              <td className="whitespace-nowrap px-6 py-3">{charity.name}</td>
              <td className="px-6 py-4">{charity.registrationNo || "N/A"}</td>
              <td className="px-6 py-4">{charity.website || "N/A"}</td>
              <td className="px-6 py-4">${charity.income || 0}</td>
              <td className="px-6 py-4">${charity.expenditure || 0}</td>
              <td className="px-6 py-4">
                {charity.id ? (
                  <div className="flex items-center justify-start gap-2">
                    <UpdateCharity id={charity.id} />
                    <DeleteCharity id={charity.id} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
